// Small helpers for the CSS visual generator cluster. The heavy lifting is UI
// (controls + live preview); these builders turn state into copyable CSS.

export type CssGeneratorVariant =
  | 'css-gradient-generator'
  | 'css-box-shadow-generator'
  | 'css-border-radius-generator'
  | 'css-triangle-generator'
  | 'css-glassmorphism-generator'
  | 'css-button-generator'
  | 'css-grid-generator';

export type GradientState = {
  type: 'linear' | 'radial';
  angle: number;
  color1: string;
  color2: string;
};

export type BoxShadowState = {
  x: number;
  y: number;
  blur: number;
  spread: number;
  color: string;
  inset: boolean;
};

export type BorderRadiusState = {
  tl: number;
  tr: number;
  br: number;
  bl: number;
};

export function gradientCss(state: GradientState): string {
  if (state.type === 'radial') {
    return `radial-gradient(circle, ${state.color1}, ${state.color2})`;
  }
  return `linear-gradient(${state.angle}deg, ${state.color1}, ${state.color2})`;
}

export function boxShadowCss(state: BoxShadowState): string {
  const inset = state.inset ? 'inset ' : '';
  return `${inset}${state.x}px ${state.y}px ${state.blur}px ${state.spread}px ${state.color}`;
}

export function borderRadiusCss(state: BorderRadiusState): string {
  return `${state.tl}px ${state.tr}px ${state.br}px ${state.bl}px`;
}
